import React, { useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  withHandlers,
  lifecycle
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import ReactSelectMaterialUi from 'react-select-material-ui';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Link from '@material-ui/core/Link';
// import Paper from '@material-ui/core/Paper';
import Modal from '@material-ui/core/Modal';
import MenuItem from '@material-ui/core/MenuItem';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Divider from '@material-ui/core/Divider';
import CardMedia from '@material-ui/core/CardMedia';
import Checkbox from '@material-ui/core/Checkbox';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import classNames from 'classnames';
import TabPanelDetail from '../../components/atoms/TabPanelDetail';
import CancelButton from '../../components/atoms/CancelButton';
import ConfirmButton from '../../components/atoms/ConfirmButton';
import RequiredButton from '../../components/atoms/RequiredButton';
import ValidationText from '../../components/atoms/ValidationText';
import AnyButton from '../../components/atoms/AnyButton';
import ShopAddConfirmGroup from './ShopAddConfirmGroup';
import FileUpload from '../../components/molecules/FileUpload';
import { countShopEmail, getZipCode } from '../../actions/Shop';
import { countPreShopName, countPreShopPhone } from '../../actions/PreShops';
import { sendLogin } from '../../auth/Auth';
import { getOptionCities } from '../../actions/Cities';
import {
  GET_BANK_BRANCH_LIST_SUCCESS,
  GET_BANK_LIST_SUCCESS,
  getBankList,
  getBankBranchList
} from '../../actions/Bank';

const styles = {
  root: {
    // position: 'absolute',
    width: '60%',
    height: 'auto',
    maxHeight: '90%',
    // top: '5%',
    // left: '2%',
    margin: 'auto',
    marginTop: '2%',
    backgroundColor: '#fff',
    padding: 28,
    overflow: 'scroll',
    outline: 'none'
  },
  mainPaper: {
    position: 'relative',
    margin: '1px 0px 10px',
    padding: '0px 0px 10px 0px'
  },
  pageTitle: {
    margin: '20px 0px 0px',
    paddingLeft: 20,
    paddingTop: 2,
    textAlign: 'left',
    backgroundColor: '#fff'
  },
  description: {
    color: '#707070',
    margin: '20px 0px 0px'
  },
  descriptionSmall: {
    fontSize: '0.875rem',
    color: '#707070',
    margin: '10px 0px 0px'
  },
  divider: {
    margin: '0px 0px 20px'
  },
  textField: {
    padding: '0px 5px 0px 5px',
    width: '300px'
  },
  textFieldFull: {
    padding: '0px 5px 0px 5px',
    width: '100%'
  },
  editTable: {
    width: 'auto'
  },
  tableCellBorderNone: {
    borderBottom: 'none'
  },
  tagCaution: {
    color: 'red',
    fontWeight: 'bold',
    textDecoration: 'underline'
  },
  marginBottom10: {
    marginBottom: '10px'
  },
  tabpanelHeader: {
    padding: '10px 0px 0px 40px',
    borderBottom: '2px solid #D8EBFF',
    minHeight: 'unset'
  },
  btnTabpanel: {
    padding: '5px 10px',
    backgroundColor: '#F7F7F7',
    borderRadius: '3px 3px 0 0',
    fontSize: 14,
    fontWeight: 600,
    color: '#777777',
    height: 'auto',
    minHeight: 'unset',
    borderTop: '5px solid #ffffff',
    width: '50%',

    '&:first-child': {
      marginRight: 2
    },
    '&:last-child': {
      marginLeft: 2
    }
  },
  tabSelected: {
    backgroundColor: '#D8EBFF',
    fontWeight: 'bold',
    color: '#000000 !important',
    borderTopColor: '#D8EBFF'
  },
  verticalAlignTop: {
    verticalAlign: 'top'
  },
  paddingTop0: {
    paddingTop: 0
  },
  paddingTop1: {
    paddingTop: 13
  },
  disableInput: {
    backgroundColor: '#d9d9d9'
  },
  link: {
    textDecoration: 'underline'
  },
  font14: {
    fontSize: 14
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      name: state.loginInfo.name,
      prefectures: state.commons.prefectures,
      cities: state.cities.listCities,
      detail: state.preShops.detail,
      shopCategories: state.commons.shopCategories,
      groupDetail: state.groups.detail
    }),
    dispatch => ({
      actions: bindActionCreators(
        {
          countShopEmail,
          countPreShopName,
          countPreShopPhone,
          getOptionCities,
          getZipCode,
          getBankList,
          getBankBranchList
        },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('shopName', 'setShopName', ''),
  withState('shopNameError', 'setShopNameError', ''),
  withState('shopNameKana', 'setShopNameKana', ''),
  withState('shopNameKanaError', 'setShopNameKanaError', ''),
  withState('zipCode', 'setZipCode', ''),
  withState('zipCodeError', 'setZipCodeError', ''),
  withState('prefectureCode', 'setPrefectureCode', 0),
  withState('prefecturesError', 'setPrefecturesError', ''),
  withState('cityIdError', 'setCityIdError', ''),
  withState('city', 'setCity', ''),
  withState('cityError', 'setCityError', ''),
  // withState('cityName', 'setCityName', ''),
  // withState('cityNameError', 'setCityNameError', ''),
  withState('address', 'setAddress', ''),
  withState('addressError', 'setAddressError', ''),
  withState('building', 'setBuilding', ''),
  withState('shopGroupName', 'setShopGroupName', ''),
  withState('shopContactName', 'setShopContactName', ''),
  withState('department', 'setDepartment', ''),
  withState('contactPhone', 'setContactPhone', ''),
  withState('contactPhoneError', 'setContactPhoneError', ''),
  withState('phone', 'setPhone', ''),
  withState('phoneError', 'setPhoneError', ''),
  withState('introduction', 'setIntroduction'),
  withState('businessHours', 'setBusinessHours', ''),
  withState('holiday', 'setHoliday', ''),
  withState('nearestStation', 'setNearestStation', ''),
  withState('priceRange', 'setPriceRange', ''),
  withState('access', 'setAccess', ''),
  withState('webPage', 'setWebPage', ''),
  withState('tagStr', 'setTagStr', ''),
  withState('tags', 'setTags', null),
  withState('tagError', 'setTagError', ''),
  withState('images', 'setImages', null),
  withState('image1', 'setImage1', null),
  withState('previewImage1', 'setPreviewImage1', null),
  withState('image2', 'setImage2', null),
  withState('previewImage2', 'setPreviewImage2', null),
  withState('image3', 'setImage3', null),
  withState('previewImage3', 'setPreviewImage3', null),
  withState('image4', 'setImage4', null),
  withState('previewImage4', 'setPreviewImage4', null),
  withState('image5', 'setImage5', null),
  withState('previewImage5', 'setPreviewImage5', null),
  withState('stealthMode', 'setStealthMode', 'UNSTEALTH'),
  withState('stealthModeStr', 'setStealthModeStr', '表示'),
  withState('gochiRestriction', 'setGochiRestriction', 'MENTION_ONLY'),
  withState('gochiRestrictionStr', 'setGochiRestrictionStr', '指名ごちのみ'),
  withState('preGochiUser', 'setPreGochiUser', ''),
  withState('preGochiUserStr', 'setPreGochiUserStr', ''),
  withState('depositManage', 'setDepositManage', 'NONSELF'),
  withState(
    'depositManageStr',
    'setDepositManageStr',
    '銀行口座で直接受取（月1回入金）（オプション）'
  ),
  withState('bankName', 'setBankName', ''),
  withState('bankBranchName', 'setBankBranchName', ''),
  withState('bankAccountType', 'setBankAccountType', 'SAVINGS'),
  withState('bankAccountTypeStr', 'setBankAccountTypeStr', '普通預金'),
  withState('bankAccountNumber', 'setBankAccountNumber', ''),
  withState('bankAccountNumberError', 'setBankAccountNumberError', ''),
  withState('bankAccountHolder', 'setBankAccountHolder', ''),
  withState('bankAccountHolderError', 'setBankAccountHolderError', ''),
  withState('cognitoUserId', 'setCognitoUserId', ''),
  withState('forcePassChanged', 'setForcePassChanged', true),
  withState('email', 'setEmail', ''),
  withState('emailError', 'setEmailError', ''),
  withState('password', 'setPassword', ''),
  withState('passwordError', 'setPasswordError', ''),
  withState('confirmPassword', 'setConfirmPassword', ''),
  withState('confirmPasswordError', 'setConfirmPasswordError', ''),
  withState('emailAuthCode', 'setEmailAuthCode', ''),
  withState('emailAuthCodeError', 'setEmailAuthCodeError', ''),
  withState('shopCategoryId', 'setShopCategoryId', 0),
  withState('shopCategoriesError', 'setShopCategoriesError', ''),
  withState('numberSit', 'setNumberSit', ''),
  withState('smoking', 'setSmoking', ''),
  withState('parking', 'setParking', ''),
  withState('snsFacebook', 'setSnsFacebook', ''),
  withState('snsTwitter', 'setSnsTwitter', ''),
  withState('snsInstagram', 'setSnsInstagram', ''),
  withState('snsFacebookError', 'setSnsFacebookError', ''),
  withState('snsTwitterError', 'setSnsTwitterError', ''),
  withState('snsInstagramError', 'setSnsInstagramError', ''),
  withState('shopContactNameError', 'setShopContactNameError', ''),
  withState('shopGroupNameError', 'setShopGroupNameError', ''),
  withState('departmentError', 'setDepartmentError', ''),
  withState('showPhone', 'setShowPhone', 1),
  withState('childShopFlag', 'setChildShopFlag', 0),
  withState('address1', 'setAddress1', ''),
  withState('address1Error', 'setAddress1Error', ''),
  withState('address2', 'setAddress2', ''),
  // withState('address2Error', 'setAddress2Error', ''),
  withState('valueTab', 'setValueTab', 0),
  withState('cashAllowed', 'setCashAllowed', 0),
  withState('allowMenuPriceShashoku', 'setAllowMenuPriceShashoku', 0),
  withState('bankCode', 'setBankCode', ''),
  withState('bankCodeError', 'setBankCodeError', ''),
  withState('bankBranchCode', 'setBankBranchCode', ''),
  withState('bankBranchCodeError', 'setBankBranchCodeError', ''),
  withState('listBank', 'setListBank', []),
  withState('listBankBranch', 'setListBankBranch', []),
  withState('haveRegistrationId', 'setHaveRegistrationId', 0),
  withState('registrationId', 'setRegistrationId', 'T'),
  withState('registrationIdError', 'setRegistrationIdError', ''),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    }
  }),
  lifecycle({
    componentDidMount() {
      this.props.actions.getOptionCities();
      this.props.actions.getBankList().then(data => {
        this.props.checkSession(data);
        if (data.type === GET_BANK_LIST_SUCCESS) {
          this.props.setListBank(data.payload);
        } else {
          this.props.setListBank([]);
        }
      });
      this.props.actions.getBankBranchList().then(data => {
        if (data.type === GET_BANK_BRANCH_LIST_SUCCESS) {
          this.props.setListBankBranch(data.payload);
        } else {
          this.props.setListBankBranch([]);
        }
      });
    }
  })
);

const Main = enhance(
  ({
    classes,
    actions,
    checkSession,
    detail, // roles,
    searchKey,
    groupShop = false,
    openShopAddConfirm,
    cancelAction,
    backAction,
    registerAction,
    shopName,
    setShopName,
    shopNameKana,
    setShopNameKana,
    zipCode,
    setZipCode,
    prefectures,
    prefectureCode,
    setPrefectureCode,
    cities,
    city,
    setCity, // address,
    // setAddress,
    address1,
    setAddress1,
    address2,
    // setAddress2,
    cityId, // cityName,
    // setCityName,
    setCityId,
    building,
    setBuilding,
    shopGroupName,
    setShopGroupName,
    shopContactName,
    setShopContactName,
    department,
    setDepartment,
    contactPhone,
    setContactPhone,
    phone,
    setPhone,
    email,
    setEmail,
    introduction,
    setIntroduction,
    businessHours,
    setBusinessHours,
    holiday,
    setHoliday,
    nearestStation,
    setNearestStation,
    priceRange,
    setPriceRange,
    access,
    setAccess,
    webPage,
    setWebPage,
    tagStr,
    setTagStr,
    tags,
    setTags,
    images,
    setImages,
    image1,
    setImage1,
    previewImage1,
    setPreviewImage1,
    image2,
    setImage2,
    previewImage2,
    setPreviewImage2,
    image3,
    setImage3,
    previewImage3,
    setPreviewImage3,
    image4,
    setImage4,
    previewImage4,
    setPreviewImage4,
    image5,
    setImage5,
    previewImage5,
    setPreviewImage5,
    stealthMode,
    setStealthMode,
    stealthModeStr,
    setStealthModeStr,
    gochiRestriction,
    setGochiRestriction,
    gochiRestrictionStr,
    setGochiRestrictionStr,
    preGochiUser,
    // setPreGochiUser,
    preGochiUserStr,
    // setPreGochiUserStr,
    depositManage,
    setDepositManage,
    depositManageStr,
    setDepositManageStr,
    bankName,
    setBankName,
    bankBranchName,
    setBankBranchName,
    bankAccountType,
    setBankAccountType,
    bankAccountTypeStr,
    setBankAccountTypeStr,
    bankAccountNumber,
    setBankAccountNumber,
    bankAccountHolder,
    setBankAccountHolder,
    cognitoUserId,
    setCognitoUserId,
    forcePassChanged,
    updateOpenShopAdd,
    updateOpenShopAddConfirm,
    shopCategories,
    shopCategoryId,
    setShopCategoryId,
    numberSit,
    setNumberSit,
    smoking,
    setSmoking,
    parking,
    setParking,
    snsFacebook,
    setSnsFacebook,
    setSnsTwitter,
    snsTwitter,
    setSnsInstagram,
    snsInstagram,
    shopNameError,
    setShopNameError,
    shopNameKanaError,
    setShopNameKanaError,
    zipCodeError,
    setZipCodeError,
    prefecturesError,
    setPrefecturesError,
    cityError, // setCityError,
    // addressError,
    // setAddressError,
    address1Error,
    setAddress1Error,
    // address2Error,
    // setAddress2Error,
    cityIdError,
    setCityIdError, // cityError,
    // setCityError,
    contactPhoneError,
    setContactPhoneError,
    phoneError,
    setPhoneError,
    emailError,
    setEmailError,
    tagError,
    setTagError,
    bankAccountNumberError,
    setBankAccountNumberError,
    bankAccountHolderError,
    setBankAccountHolderError,
    shopCategoriesError,
    setShopCategoriesError,
    snsFacebookError,
    setSnsFacebookError,
    snsTwitterError,
    setSnsTwitterError,
    snsInstagramError,
    setSnsInstagramError,
    shopContactNameError,
    shopGroupNameError,
    departmentError,
    setShopContactNameError,
    setShopGroupNameError,
    setDepartmentError,
    showPhone,
    setShowPhone,
    childShopFlag, // setChildShopFlag,
    paymentGroupType,
    valueTab,
    setValueTab,
    onAddSuccess,
    cashAllowed,
    // setCashAllowed,
    allowMenuPriceShashoku,
    setAllowMenuPriceShashoku,
    groupDetail,
    bankCode,
    setBankCode,
    bankCodeError,
    setBankCodeError,
    listBank,
    bankBranchCode,
    setBankBranchCode,
    bankBranchCodeError,
    setBankBranchCodeError,
    listBankBranch,
    haveRegistrationId,
    setHaveRegistrationId,
    registrationId,
    setRegistrationId,
    registrationIdError,
    setRegistrationIdError
  }) => {
    const addConfirm = {
      shopName,
      shopNameKana,
      zipCode,
      prefectureCode,
      city,
      // address,
      address1,
      address2,
      // cityName,
      building,
      shopGroupName,
      shopContactName,
      department,
      contactPhone,
      phone,
      email,
      businessHours,
      introduction,
      holiday,
      nearestStation,
      priceRange,
      access,
      webPage,
      tagStr,
      previewImage1,
      previewImage2,
      previewImage3,
      previewImage4,
      previewImage5,
      stealthModeStr,
      gochiRestrictionStr,
      preGochiUserStr,
      depositManageStr,
      bankName,
      bankBranchName,
      bankAccountTypeStr,
      bankAccountNumber,
      bankAccountHolder,
      shopCategoryId,
      numberSit,
      smoking,
      parking,
      snsFacebook,
      snsTwitter,
      snsInstagram,
      showPhone,
      childShopFlag,
      cashAllowed,
      allowMenuPriceShashoku,
      bankCode,
      bankBranchCode,
      haveRegistrationId,
      registrationId: haveRegistrationId ? registrationId : undefined
    };
    const bankAccount = {
      bankName,
      bankBranchName,
      bankAccountType,
      bankAccountNumber,
      bankAccountHolder,
      bankCode,
      bankBranchCode
    };
    const addParam = {
      groupId: searchKey.groupId || null,
      shopName,
      shopNameKana,
      zipCode,
      prefectureCode,
      city,
      // address,
      address1,
      address2,
      // cityName,
      cityId,
      building,
      shopGroupName,
      shopContactName,
      department,
      contactPhone,
      phone,
      businessHours,
      introduction,
      holiday,
      nearestStation,
      priceRange,
      access,
      webPage,
      tags,
      images,
      stealthMode,
      gochiRestriction,
      inviteUserId: preGochiUser,
      depositManage,
      bankAccount,
      cognitoUserId,
      forcePassChanged,
      email,
      shopCategoryId,
      numberSit,
      smoking,
      parking,
      snsFacebook,
      snsTwitter,
      snsInstagram,
      showPhone,
      childShopFlag,
      cashAllowed,
      shopDetail: { allowMenuPriceShashoku },
      registrationId: haveRegistrationId ? registrationId : undefined
    };

    const errors = {
      shopNameError,
      shopNameKanaError,
      zipCodeError,
      prefecturesError,
      cityError,
      // addressError,
      address1Error,
      // address2Error,
      // cityError,
      cityIdError,
      contactPhoneError,
      phoneError,
      emailError,
      tagError,
      bankAccountNumberError,
      bankAccountHolderError,
      shopCategoriesError,
      snsFacebookError,
      snsTwitterError,
      snsInstagramError,
      shopContactNameError,
      shopGroupNameError,
      departmentError,
      bankCodeError,
      bankBranchCodeError,
      registrationIdError
    };
    const enableShopBank = !paymentGroupType;

    const checkCityName = () => {
      console.log('city', city);
      const chosenCityNameList = [];
      cities
        .filter(item => item.cityName && item.cityName === city)
        .forEach(item => {
          chosenCityNameList.push({
            label: item.cityName,
            value: String(item.cityId)
          });
        });
      if (chosenCityNameList.length > 0) {
        return Number(chosenCityNameList[0].value);
      }
      return Number(0);
    };

    useEffect(() => {
      setCityId(checkCityName());
    }, [city]);

    const getZipCodeData = async zipcode => {
      await actions.getZipCode(zipcode).then(data => {
        setPrefectureCode(data.payload.prefectureCode);
        setCity(data.payload.city ? data.payload.city : 0);
        // setAddress(data.payload.address ? data.payload.address : '');
        setAddress1(data.payload.address1 ? data.payload.address1 : '');
        // setAddress2(data.payload.address2 ? data.payload.address2 : '');
      });
    };

    const validShopName = () => {
      const value = shopName.trim();
      if (value === '') {
        setShopNameError('必須項目です。');
        return 1;
      }
      setShopNameError('');
      setShopName(value);
      return 0;
    };
    const validShopNameCount = async () => {
      const value = shopName.trim();
      if (value !== '') {
        const nameData = await actions
          .countPreShopName({
            preShopNameMatch: value,
            includeUnregisteredShop: true
          })
          .then();
        if (nameData.payload.totalCount > 0) {
          setShopNameError(
            '同様の名前の店舗が仮登録されています。お手数ですが前画面に戻り、そちらから登録ください。'
          );
          return 1;
        }
      }
      return 0;
    };
    const validShopNameKana = () => {
      const value = shopNameKana.trim();
      if (value === '') {
        setShopNameKanaError('必須項目です。');
        return 1;
      }
      if (!/^[\u3040-\u309F\s\d０-９ー]+$/.test(value)) {
        setShopNameKanaError('ひらがなで入力してください。');
        return 1;
      }
      setShopNameKanaError('');
      setShopNameKana(value);
      return 0;
    };
    const validZipCode = () => {
      const value = zipCode.trim();
      if (value === '') {
        setZipCodeError('必須項目です。');
        return 1;
      }
      if (!/^\d{7}$/.test(value)) {
        setZipCodeError('0000000形式で入力してください。');
        return 1;
      }
      setZipCodeError('');
      setZipCode(value);
      getZipCodeData(value);
      return 0;
    };
    const validZipCodeSubmit = () => {
      const value = zipCode.trim();
      if (value === '') {
        setZipCodeError('必須項目です。');
        return 1;
      }
      if (!/^\d{7}$/.test(value)) {
        setZipCodeError('0000000形式で入力してください。');
        return 1;
      }
      setZipCodeError('');
      setZipCode(value);
      return 0;
    };
    const validPrefectures = () => {
      const value = prefectureCode;
      if (value === 0) {
        setPrefecturesError('必須項目です。');
        return 1;
      }
      setPrefecturesError('');
      setPrefectureCode(value);
      return 0;
    };
    const validCityId = () => {
      const value = cityId;
      if (value === 0) {
        setCityIdError('必須項目です。');
        return 1;
      }
      setCityIdError('');
      setCityId(value);
      return 0;
    };
    const setCityNameData = id => {
      cities.forEach(item => {
        if (id === item.cityId) {
          setCity(item.cityName);
        }
      });
    };
    const validShopCategories = () => {
      const value = shopCategoryId;
      if (value === 0) {
        setShopCategoriesError('必須項目です。');
        return 1;
      }
      setShopCategoriesError('');
      setShopCategoryId(value);
      return 0;
    };
    const validSnsFacebook = () => {
      const value = snsFacebook;
      const pattern = /(http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-/]))?/;
      if (value && !pattern.test(value)) {
        setSnsFacebookError('URLを入力してください');
        return 1;
      }
      setSnsFacebookError('');
      setSnsFacebook(value);
      return 0;
    };
    const validSnsTwitter = () => {
      const value = snsTwitter;
      const pattern = /(http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-/]))?/;
      if (value && !pattern.test(value)) {
        setSnsTwitterError('URLを入力してください');
        return 1;
      }
      setSnsTwitterError('');
      setSnsTwitter(value);
      return 0;
    };
    const validSnsInstagram = () => {
      const value = snsInstagram;
      const pattern = /(http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-/]))?/;
      if (value && !pattern.test(value)) {
        setSnsInstagramError('URLを入力してください');
        return 1;
      }
      setSnsInstagramError('');
      setSnsInstagram(value);
      return 0;
    };
    // const validAddress = () => {
    //   const value = address.trim();
    //   if (value === '') {
    //     setAddressError('必須項目です。');
    //     return 1;
    //   }
    //   setAddressError('');
    //   setAddress(value);
    //   return 0;
    // };
    const validAddress1 = () => {
      const value = address1 ? address1.trim() : '';
      if (value === '') {
        setAddress1Error('必須項目です。');
        return 1;
      }
      setAddress1Error('');
      setAddress1(value);
      return 0;
    };
    // const validAddress2 = () => {
    //  const value = address2 ? address2.trim() : '';
    //  if (value === '') {
    //    setAddress2Error('必須項目です。');
    //    return 1;
    //  }
    //  setAddress2Error('');
    //  setAddress2(value);
    //  return 0;
    // };
    const validShopContactName = () => {
      const value = shopContactName.trim();
      if (value === '') {
        setShopContactNameError('必須項目です。');
        return 1;
      }
      setShopContactNameError('');
      setShopContactName(value);
      return 0;
    };
    const validShopGroupName = () => {
      const value = shopGroupName.trim();
      if (value === '') {
        setShopGroupNameError('必須項目です。');
        return 1;
      }
      setShopGroupNameError('');
      setShopGroupName(value);
      return 0;
    };
    const validDepartment = () => {
      const value = department.trim();
      if (value === '') {
        setDepartmentError('必須項目です。');
        return 1;
      }
      setDepartmentError('');
      setDepartment(value);
      return 0;
    };
    const validContactPhone = () => {
      const value = contactPhone.trim();
      if (value === '') {
        setContactPhoneError('必須項目です。');
        return 1;
      }
      if (value !== '' && !/^\d+$/.test(value)) {
        setContactPhoneError('数字をハイフン(-)なしで入力してください。');
        return 1;
      }
      setContactPhoneError('');
      setContactPhone(value);
      return 0;
    };
    const validPhone = () => {
      const value = phone.trim();
      if (value === '') {
        setPhoneError('必須項目です。');
        return 1;
      }
      if (!/^\d+$/.test(value)) {
        setPhoneError('数字をハイフン(-)なしで入力してください。');
        return 1;
      }
      setPhoneError('');
      setPhone(value);
      return 0;
    };
    const validPhoneCount = async () => {
      const value = phone.trim();
      if (value !== '') {
        const phoneData = await actions
          .countPreShopPhone({
            phone: value,
            includeUnregisteredShop: true
          })
          .then();
        if (phoneData.payload.totalCount > 0) {
          setPhoneError(
            '同様の電話番号の店舗が仮登録されています。お手数ですが前画面に戻りそちらから登録ください。'
          );
          return 1;
        }
      }
      return 0;
    };
    const validEmail = () => {
      const value = email.trim();
      if (value === '') {
        setEmailError('必須項目です。');
        return 1;
      }
      setEmailError('');
      setEmail(value);
      return 0;
    };
    const validEmailCount = emailData => {
      const value = email.trim();
      if (value !== '' && emailData.payload.totalCount > 0) {
        setEmailError('メールアドレスが既に登録されています。');
        return 1;
      }
      return 0;
    };
    const validTag = () => {
      const value = tagStr.trim();
      if (
        value !== '' &&
        tags
          .map(tag => {
            if (tag.tagName.length > 30) {
              return 1;
            }
            return 0;
          })
          .includes(1)
      ) {
        setTagError(
          '1つのタグは30文字以内で入力してください。タグとタグの間はスペースで区切ってください。'
        );
        return 1;
      }
      setTagError('');
      setTagStr(value);
      return 0;
    };
    const validBankAccountNumber = () => {
      const value = bankAccountNumber.trim();
      if (enableShopBank && depositManage === 'NONSELF') {
        if (value === '') {
          setBankAccountNumberError('必須項目です。');
          return 1;
        }
        if (!/^\d{7}$/.test(value)) {
          setBankAccountNumberError('半角数字のみで7桁で入力してください。');
          return 1;
        }
      }
      setBankAccountNumberError('');
      setBankAccountNumber(value);
      return 0;
    };
    const validBankAccountHolder = () => {
      const value = bankAccountHolder.trim();
      if (enableShopBank && depositManage === 'NONSELF') {
        if (value === '') {
          setBankAccountHolderError('必須項目です。');
          return 1;
        }
        if (
          !/^[0-9a-zA-Z!-/:-@¥[-`{-~！-／：-＠［-｀｛-～、-〜”’・ー‐−―￥ァ-ヴ\x20\u3000]+$/.test(
            value
          )
        ) {
          setBankAccountHolderError('漢字/ひらがな以外で入力してください。');
          return 1;
        }
      }
      setBankAccountHolderError('');
      setBankAccountHolder(value);
      return 0;
    };
    const convertShowPhone = checked => {
      if (checked) {
        setShowPhone(0);
      } else {
        setShowPhone(1);
      }
    };
    // const convertChildShopFlag = checked => {
    //   if (checked) {
    //     setChildShopFlag(1);
    //   } else {
    //     setChildShopFlag(0);
    //   }
    // };
    const getBankName = bankCodeValue => {
      let listBankName = [];
      listBankName = listBank.filter(bank => bank.bankCode === bankCodeValue);
      if (listBankName.length === 0) {
        setBankCodeError('データが正しくありません。');
        setBankName('');
        return false;
      }
      setBankName(listBankName[0].bankName);
      return true;
    };

    const getBankBranchName = bankBranchCodeValue => {
      let listBankBranchName = [];
      listBankBranchName = listBankBranch.filter(
        bankBranch => bankBranch.uniqueCode === bankCode + bankBranchCodeValue
      );
      if (listBankBranchName.length === 0) {
        setBankBranchCodeError('データが正しくありません。');
        setBankBranchName('');
        return false;
      }
      setBankBranchName(listBankBranchName[0].bankBranchName);
      return true;
    };

    const validBankCode = () => {
      const value = bankCode;
      if (enableShopBank && depositManage === 'NONSELF') {
        if (!value) {
          setBankCodeError('必須項目です。');
          return 1;
        }
        if (!/^[0-9\b]+$/.test(value)) {
          setBankCodeError('データが正しくありません。');
          return 1;
        }
        if (value.length !== 4) {
          setBankCodeError('データが正しくありません。');
          return 1;
        }
        if (!getBankName(value)) {
          return 1;
        }
      }
      setBankCodeError('');
      return 0;
    };

    const validBankBranchCode = () => {
      const value = bankBranchCode;
      if (enableShopBank && depositManage === 'NONSELF') {
        if (!value) {
          setBankBranchCodeError('必須項目です。');
          return 1;
        }
        if (!/^[0-9\b]+$/.test(value)) {
          setBankBranchCodeError('データが正しくありません。');
          return 1;
        }
        if (value.length !== 3) {
          setBankBranchCodeError('データが正しくありません。');
          return 1;
        }
        if (!getBankBranchName(value)) {
          return 1;
        }
      }
      setBankBranchCodeError('');
      return 0;
    };

    const validRegistrationId = () => {
      const value = registrationId;
      if (haveRegistrationId === 1) {
        const valueNumber = value.slice(1);
        if (!value || !valueNumber) {
          setRegistrationIdError('必須項目です。');
          return 1;
        }
        if (!/^\d+$/.test(valueNumber)) {
          setRegistrationIdError('半角数字のみ入力してください。');
          return 1;
        }
        if (valueNumber.length !== 13) {
          setRegistrationIdError('13桁の番号をご入力ください。');
          return 1;
        }
      }
      setRegistrationId(value);
      setRegistrationIdError('');
      return 0;
    };

    const valid = async emailData => {
      let errorCount =
        validShopName() +
        validShopNameKana() +
        validZipCodeSubmit() +
        validPrefectures() +
        // validCity() +
        // validAddress() +
        validAddress1() +
        // validAddress2() +
        validCityId() +
        validContactPhone() +
        validPhone() +
        validEmail() +
        validEmailCount(emailData) +
        validTag() +
        validBankAccountNumber() +
        validBankAccountHolder() +
        validShopCategories() +
        validSnsFacebook() +
        validSnsTwitter() +
        validSnsInstagram() +
        validShopContactName() +
        validShopGroupName() +
        validDepartment() +
        validBankCode() +
        validBankBranchCode() +
        validRegistrationId();
      await Promise.all([validShopNameCount(), validPhoneCount()]).then(
        values => {
          errorCount += values[0] + values[1];
        }
      );
      if (errorCount === 0) {
        return true;
      }
      return false;
    };

    const splitTagStr = str => {
      if (str === '') {
        setTags(null);
      } else {
        setTags(
          str.split(/\s+/).map(t => {
            return { tagName: t };
          })
        );
      }
    };
    const convertStealthModeStr = mode => {
      if (mode === 'UNSTEALTH') {
        setStealthModeStr('表示');
      } else {
        setStealthModeStr('非表示');
      }
    };
    const convertGochiRestrictionStr = mode => {
      if (mode === 'MENTION_ONLY') {
        setGochiRestrictionStr('指名ごちのみ');
      } else {
        setGochiRestrictionStr('制限なし');
      }
    };
    // const convertPreGochiUserStr = userId => {
    //   detail.preGochis.forEach(preGochi => {
    //     if (userId === preGochi.userId) {
    //       setPreGochiUserStr(
    //         `${preGochi.accountId}(${preGochi.displayName})[${preGochi.amount}]`
    //       );
    //     }
    //   });
    // };
    const convertDepositManageStr = mode => {
      if (mode === 'SELF') {
        setDepositManageStr('Stripe経由で受取（週1回入金）');
      } else {
        setDepositManageStr('銀行口座で直接受取（月1回入金）（オプション）');
      }
    };
    const convertBankAccountTypeStr = mode => {
      if (mode === 'SAVINGS') {
        setBankAccountTypeStr('普通預金');
      } else {
        setBankAccountTypeStr('当座預金');
      }
    };
    const convertImages = () => {
      const imageArray = {
        0: {
          image: image1,
          viewOrder: 0
        },
        1: {
          image: image2,
          viewOrder: 1
        },
        2: {
          image: image3,
          viewOrder: 2
        },
        3: {
          image: image4,
          viewOrder: 3
        },
        4: {
          image: image5,
          viewOrder: 4
        }
      };
      setImages(imageArray);
    };

    const confirmAction = async () => {
      const emailData = await actions
        .countShopEmail(email.trim())
        .then(data => checkSession(data));
      valid(emailData).then(validCheckOK => {
        if (!validCheckOK) {
          alert('登録情報を正しく入力してください。');
        } else {
          setCityNameData(cityId);
          convertImages();
          updateOpenShopAddConfirm(true);
        }
      });
    };

    const getCitiesOptions = () => {
      const citiesOptions = [];
      const tmpObj = { label: '', value: '0' };
      if (!prefectureCode || prefectureCode === 0) {
        cities.forEach(item => {
          citiesOptions.push({
            label: item.cityName,
            value: String(item.cityId)
          });
        });
      } else {
        cities
          .filter(
            item =>
              item.prefCode && Number(item.prefCode) === Number(prefectureCode)
          )
          .forEach(item => {
            citiesOptions.push({
              label: item.cityName,
              value: String(item.cityId)
            });
          });
      }
      return { ...citiesOptions, tmpObj };
    };
    const handleChange = (event, newValue) => {
      setValueTab(newValue);
    };
    const handleChangeBankCode = value => {
      setBankCode(value);
      setBankName('');
      setBankBranchCode('');
      setBankBranchName('');
    };
    return (
      <div className={classes.root}>
        <div className={classes.pageTitle}>
          <Typography variant="h5">グループ店舗 追加</Typography>
          <Typography className={classes.description}>
            ごちめしアプリを店舗としてご利用いただく方は、以下の申込みフォームにご記入ください。
            <br />
            ご記入にあたっては、こちらの
            <Link
              href="https://gochimeshi.com/policy/owner-terms/"
              target="_blank"
              rel="noreferrer"
            >
              【ごちめし加盟店規約】
            </Link>
            をご参照、ご同意いただけますようお願いいたします。
          </Typography>
        </div>
        <Tabs
          value={valueTab}
          onChange={handleChange}
          indicatorColor="primary"
          textColor="primary"
          // centered
          className={classes.tabpanelHeader}
        >
          <Tab
            label="基本情報（必須）"
            className={classNames(
              classes.btnTabpanel,
              valueTab === 0 && classes.tabSelected
            )}
          />
          <Tab
            label="その他（任意）"
            className={classNames(
              classes.btnTabpanel,
              valueTab === 1 && classes.tabSelected
            )}
          />
        </Tabs>
        <div className={classes.mainPaper}>
          <TabPanelDetail value={valueTab} index={0}>
            <Table className={classes.editTable}>
              <TableBody>
                <TableRow className={classes.verticalAlignTop}>
                  <TableCell>
                    <RequiredButton />
                  </TableCell>
                  <TableCell className={classes.paddingTop0}>
                    <TextField
                      required
                      label="店舗名"
                      placeholder="ごち屋　天神店"
                      className={classes.textFieldFull}
                      margin="normal"
                      onChange={e => {
                        setShopName(e.target.value);
                      }}
                      onBlur={() => {
                        validShopName();
                        validShopNameCount();
                      }}
                    />
                    <ValidationText message={errors.shopNameError} />
                  </TableCell>
                  <TableCell />
                </TableRow>
                <TableRow className={classes.verticalAlignTop}>
                  <TableCell>
                    <RequiredButton />
                  </TableCell>
                  <TableCell className={classes.paddingTop0}>
                    <TextField
                      required
                      label="店舗名かな"
                      placeholder="ごちや　てんじんてん"
                      className={classes.textFieldFull}
                      margin="normal"
                      onChange={e => {
                        setShopNameKana(e.target.value);
                      }}
                      onBlur={validShopNameKana}
                    />
                    <ValidationText message={errors.shopNameKanaError} />
                  </TableCell>
                  <TableCell />
                </TableRow>
                <TableRow className={classes.verticalAlignTop}>
                  <TableCell>
                    <RequiredButton />
                  </TableCell>
                  <TableCell className={classes.paddingTop0}>
                    <TextField
                      required
                      label="店舗電話番号"
                      placeholder="09012345678"
                      className={classes.textFieldFull}
                      margin="normal"
                      onChange={e => {
                        setPhone(e.target.value);
                      }}
                      onBlur={() => {
                        validPhone();
                        validPhoneCount();
                      }}
                    />
                    <br />
                    <Typography variant="h7">
                      ハイフンなしで記載ください
                    </Typography>
                    <br />
                    <FormControlLabel
                      control={<Checkbox id="showPhone" color="primary" />}
                      label="電話番号を非表示します。"
                      value={showPhone}
                      onChange={e => {
                        setShowPhone(e.target.checked);
                        convertShowPhone(e.target.checked);
                      }}
                    />
                    <ValidationText message={errors.phoneError} />
                  </TableCell>
                  <TableCell />
                </TableRow>
                <TableRow className={classes.verticalAlignTop}>
                  <TableCell className={classes.tableCellBorderNone}>
                    <RequiredButton />
                  </TableCell>
                  <TableCell
                    className={[
                      classes.tableCellBorderNone,
                      classes.paddingTop0
                    ]}
                  >
                    <TextField
                      required
                      fullWidth
                      label="郵便番号"
                      className={classes.textFieldFull}
                      placeholder="0001111"
                      margin="normal"
                      onChange={e => {
                        setZipCode(e.target.value);
                      }}
                      onBlur={validZipCode}
                    />
                    <br />
                    <Typography variant="h7">
                      ハイフンなしで記載ください
                    </Typography>
                    <ValidationText message={errors.zipCodeError} />
                  </TableCell>
                  <TableCell className={classes.tableCellBorderNone} />
                </TableRow>
                <TableRow className={classes.verticalAlignTop}>
                  <TableCell className={classes.tableCellBorderNone} />
                  <TableCell
                    className={[
                      classes.tableCellBorderNone,
                      classes.paddingTop0
                    ]}
                  >
                    <TextField
                      required
                      select
                      fullWidth
                      label="都道府県"
                      className={classes.textFieldFull}
                      margin="normal"
                      value={prefectureCode}
                      onChange={e => {
                        setPrefectureCode(e.target.value);
                        setCityId(Number(0));
                      }}
                      InputLabelProps={{
                        shrink: true
                      }}
                      onBlur={validPrefectures}
                    >
                      {prefectures.map(item => {
                        return (
                          <MenuItem key={item.id} value={item.id}>
                            {item.name}
                          </MenuItem>
                        );
                      })}
                    </TextField>
                    <ValidationText message={errors.prefecturesError} />
                  </TableCell>
                  {/* <TableCell className={classes.tableCellBorderNone} /> */}
                </TableRow>
                {prefectureCode > 0 && (
                  <TableRow className={classes.verticalAlignTop}>
                    <TableCell className={classes.tableCellBorderNone} />
                    <TableCell
                      className={[
                        classes.tableCellBorderNone,
                        classes.paddingTop0
                      ]}
                    >
                      <ReactSelectMaterialUi
                        required
                        fullWidth
                        label="市区町村*"
                        className={classes.textFieldFull}
                        defaultValue={String(cityId)}
                        value={String(cityId)}
                        options={getCitiesOptions()}
                        margin="normal"
                        onChange={z => {
                          setCityId(Number(z));
                        }}
                        SelectProps={{
                          isClearable: true,
                          msgNoOptionsMatchFilter:
                            '名前が部分一致する店舗がありません'
                        }}
                        onBlur={validCityId}
                      />
                      <ValidationText message={errors.cityIdError} />
                    </TableCell>
                    {/* <TableCell className={classes.tableCellBorderNone} /> */}
                  </TableRow>
                )}
                {(!prefectureCode || prefectureCode <= 0) && (
                  <TableRow className={classes.verticalAlignTop}>
                    <TableCell className={classes.tableCellBorderNone} />
                    <TableCell
                      className={[
                        classes.tableCellBorderNone,
                        classes.paddingTop0
                      ]}
                    >
                      <ReactSelectMaterialUi
                        disabled
                        required
                        label="市区町村*"
                        className={classes.textFieldFull}
                        defaultValue={String(cityId)}
                        value={String(cityId)}
                        options={getCitiesOptions()}
                        margin="normal"
                        onChange={z => {
                          setCityId(Number(z));
                        }}
                        SelectProps={{
                          isClearable: true,
                          msgNoOptionsMatchFilter:
                            '名前が部分一致する店舗がありません'
                        }}
                        onBlur={validCityId}
                      />
                      <ValidationText message={errors.cityIdError} />
                    </TableCell>
                    {/* <TableCell className={classes.tableCellBorderNone} /> */}
                  </TableRow>
                )}
                <TableRow className={classes.verticalAlignTop}>
                  <TableCell className={classes.tableCellBorderNone} />
                  <TableCell
                    className={[
                      classes.tableCellBorderNone,
                      classes.paddingTop0
                    ]}
                  >
                    <TextField
                      required
                      label="町域・番地"
                      placeholder="天神"
                      className={classes.textFieldFull}
                      margin="normal"
                      value={address1}
                      onChange={e => {
                        setAddress1(e.target.value);
                      }}
                      onBlur={validAddress1}
                    />
                    <ValidationText message={errors.address1Error} />
                  </TableCell>
                  <TableCell className={classes.tableCellBorderNone} />
                </TableRow>
                {/* <TableRow className={classes.verticalAlignTop}>
                  <TableCell className={classes.tableCellBorderNone} />
                  <TableCell
                    className={[
                      classes.tableCellBorderNone,
                      classes.paddingTop0
                    ]}
                  >
                    <TextField
                      required
                      label="番地"
                      placeholder="1-2-3"
                      className={classes.textFieldFull}
                      margin="normal"
                      value={address2}
                      onChange={e => {
                        setAddress2(e.target.value);
                      }}
                      onBlur={validAddress2}
                    />
                    <ValidationText message={errors.address2Error} />
                  </TableCell>
                  <TableCell className={classes.tableCellBorderNone} />
                </TableRow> */}
                <TableRow className={classes.verticalAlignTop}>
                  <TableCell />
                  <TableCell className={classes.paddingTop0}>
                    <TextField
                      label="建物名"
                      placeholder="○○ビル 102号"
                      className={classes.textFieldFull}
                      margin="normal"
                      onChange={e => {
                        setBuilding(e.target.value);
                      }}
                    />
                  </TableCell>
                  <TableCell />
                </TableRow>
                <TableRow className={classes.verticalAlignTop}>
                  <TableCell>
                    <RequiredButton />
                  </TableCell>
                  <TableCell className={classes.paddingTop0}>
                    <TextField
                      required
                      select
                      label="店舗カテゴリー"
                      className={classes.textFieldFull}
                      margin="normal"
                      value={shopCategoryId}
                      onChange={e => {
                        setShopCategoryId(e.target.value);
                      }}
                      InputLabelProps={{
                        shrink: true
                      }}
                      onBlur={validShopCategories}
                    >
                      {shopCategories.map(item => {
                        return (
                          <MenuItem key={item.id} value={item.id}>
                            {item.name}
                          </MenuItem>
                        );
                      })}
                    </TextField>
                    <ValidationText message={errors.shopCategoriesError} />
                  </TableCell>
                  <TableCell />
                </TableRow>
                <TableRow className={classes.verticalAlignTop}>
                  <TableCell className={classes.tableCellBorderNone}>
                    <RequiredButton />
                  </TableCell>
                  <TableCell className={classes.tableCellBorderNone}>
                    (店舗オーナーさまへの依頼）
                    <br />
                    店舗オーナーさまが登録された店舗の現場に連絡しても、
                    「ごちめし」のことを全く知らないという事例が発生してきています。
                    店舗登録時には現場の責任者に了解を取った後に登録ください
                  </TableCell>
                </TableRow>
                <TableRow className={classes.verticalAlignTop}>
                  <TableCell className={classes.tableCellBorderNone} />
                  <TableCell
                    className={[
                      classes.tableCellBorderNone,
                      classes.paddingTop0
                    ]}
                  >
                    <TextField
                      required
                      label="運営会社"
                      defaultValue={detail.shopGroupName}
                      fullWidth
                      className={classes.textFieldFull}
                      margin="normal"
                      onChange={e => {
                        setShopGroupName(e.target.value);
                      }}
                      onBlur={validShopGroupName}
                    />
                    <br />
                    <Typography variant="h7">
                      個人店の場合は「なし」と記載ください
                    </Typography>
                    <ValidationText message={errors.shopGroupNameError} />
                  </TableCell>
                </TableRow>
                <TableRow className={classes.verticalAlignTop}>
                  <TableCell className={classes.tableCellBorderNone} />
                  <TableCell
                    className={[
                      classes.tableCellBorderNone,
                      classes.paddingTop0
                    ]}
                  >
                    <TextField
                      required
                      label="ご担当者名"
                      defaultValue={detail.shopContactName}
                      fullWidth
                      className={classes.textFieldFull}
                      margin="normal"
                      onChange={e => {
                        setShopContactName(e.target.value);
                      }}
                      onBlur={validShopContactName}
                    />
                    <ValidationText message={errors.shopContactNameError} />
                  </TableCell>
                </TableRow>
                <TableRow className={classes.verticalAlignTop}>
                  <TableCell className={classes.tableCellBorderNone} />
                  <TableCell
                    className={[
                      classes.tableCellBorderNone,
                      classes.paddingTop0
                    ]}
                  >
                    <TextField
                      required
                      label="所属部署"
                      defaultValue={detail.department}
                      fullWidth
                      className={classes.textFieldFull}
                      margin="normal"
                      onChange={e => {
                        setDepartment(e.target.value);
                      }}
                      onBlur={validDepartment}
                    />
                    <br />
                    <Typography variant="h7">
                      個人店の場合は「なし」と記載ください
                    </Typography>
                    <ValidationText message={errors.departmentError} />
                  </TableCell>
                </TableRow>
                <TableRow className={classes.verticalAlignTop}>
                  <TableCell />
                  <TableCell className={classes.paddingTop0}>
                    <TextField
                      required
                      label="電話番号（担当者）"
                      defaultValue={detail.contactPhone}
                      fullWidth
                      className={classes.textFieldFull}
                      margin="normal"
                      onChange={e => {
                        setContactPhone(e.target.value);
                      }}
                      onBlur={validContactPhone}
                    />
                    <br />
                    <Typography variant="h7">
                      ハイフンなしで記載ください
                    </Typography>
                    <ValidationText message={errors.contactPhoneError} />
                  </TableCell>
                </TableRow>
                {enableShopBank && (
                  <>
                    <TableRow className={classes.verticalAlignTop}>
                      <TableCell>
                        <RequiredButton />
                      </TableCell>
                      <TableCell className={classes.paddingTop0}>
                        <Typography className={classes.description}>
                          インボイス制度 適格事業者登録*
                        </Typography>
                        <RadioGroup
                          row
                          value={haveRegistrationId}
                          onChange={e => {
                            setHaveRegistrationId(parseInt(e.target.value, 10));
                          }}
                        >
                          <FormControlLabel
                            value={0}
                            control={<Radio color="primary" />}
                            label="未登録"
                            disabled={!enableShopBank}
                          />
                          <FormControlLabel
                            value={1}
                            control={<Radio color="primary" />}
                            label="登録済み"
                            disabled={!enableShopBank}
                          />
                        </RadioGroup>
                      </TableCell>
                    </TableRow>
                    {haveRegistrationId === 1 && (
                      <TableRow className={classes.verticalAlignTop}>
                        <TableCell />
                        <TableCell className={classes.paddingTop0}>
                          <TextField
                            required
                            label="適格事業者登録番号"
                            className={classes.textFieldFull}
                            margin="normal"
                            onChange={e => {
                              if (e.target.value[0] === 'T') {
                                setRegistrationId(e.target.value);
                              } else if (!e.target.value) {
                                setRegistrationId('T');
                              }
                            }}
                            value={registrationId}
                            onBlur={validRegistrationId}
                          />
                          <ValidationText
                            message={errors.registrationIdError}
                          />
                          <Typography variant="h7">
                            Tの後に続く13桁の番号を入力してください。
                          </Typography>
                        </TableCell>
                      </TableRow>
                    )}
                  </>
                )}
                <TableRow className={classes.verticalAlignTop}>
                  <TableCell>
                    <RequiredButton />
                  </TableCell>
                  <TableCell className={classes.paddingTop0}>
                    <TextField
                      required
                      label="メールアドレス"
                      placeholder="gochimeshi@gochi.com"
                      type="email"
                      className={classes.textFieldFull}
                      margin="normal"
                      onChange={e => {
                        setEmail(e.target.value);
                      }}
                      onBlur={validEmail}
                    />
                    <br />
                    <Typography variant="h7">
                      他の店舗で使用したメールアドレスは使用できません。
                      <br />
                      一つの店舗に一つのメールアドレスを割り当ててください。
                    </Typography>
                    <ValidationText message={errors.emailError} />
                  </TableCell>
                  <TableCell />
                </TableRow>
                <TableRow className={classes.verticalAlignTop}>
                  <TableCell>
                    <RequiredButton />
                  </TableCell>
                  <TableCell className={classes.paddingTop0}>
                    <Typography className={classes.description}>
                      店舗詳細表示制限
                    </Typography>
                    <RadioGroup
                      row
                      value={stealthMode}
                      onChange={e => {
                        setStealthMode(e.target.value);
                        convertStealthModeStr(e.target.value);
                      }}
                    >
                      <FormControlLabel
                        value="UNSTEALTH"
                        control={<Radio color="primary" />}
                        label="店舗詳細表示"
                      />
                      <FormControlLabel
                        value="STEALTH"
                        control={<Radio color="primary" />}
                        label="店舗詳細非表示"
                      />
                    </RadioGroup>
                    <Typography variant="h7">
                      非表示を選択した場合は、ごちめしアプリに店舗の詳細情報が表示されません。
                    </Typography>
                  </TableCell>
                </TableRow>
                <TableRow className={classes.verticalAlignTop}>
                  <TableCell>
                    <RequiredButton />
                  </TableCell>
                  <TableCell className={classes.paddingTop0}>
                    <Typography className={classes.description}>
                      誰でもごち制限
                    </Typography>
                    <RadioGroup
                      row
                      value={gochiRestriction}
                      onChange={e => {
                        setGochiRestriction(e.target.value);
                        convertGochiRestrictionStr(e.target.value);
                      }}
                    >
                      <FormControlLabel
                        selected
                        value="MENTION_ONLY"
                        control={<Radio color="primary" />}
                        label="指名ごちのみ"
                      />
                      <FormControlLabel
                        value="ANY"
                        control={<Radio color="primary" />}
                        label="制限なし"
                      />
                    </RadioGroup>
                    <Typography variant="h7">
                      指名ごちのみを選択した場合は、利用者を指名したごちのみ利用可能となります。
                    </Typography>
                  </TableCell>
                </TableRow>
                {/* <TableRow className={classes.verticalAlignTop}>
                  <TableCell>
                    <RequiredButton />
                  </TableCell>
                  <TableCell className={classes.paddingTop0}>
                    <Typography className={classes.description}>
                      社食ごちめし現金授受の有無
                    </Typography>
                    <RadioGroup
                      row
                      value={cashAllowed}
                      onChange={e => {
                        const allowed = parseInt(e.target.value, 10);
                        setCashAllowed(allowed);
                      }}
                    >
                      <FormControlLabel
                        selected
                        value={0}
                        control={<Radio color="primary" />}
                        label="受け付けない"
                      />
                      <FormControlLabel
                        value={1}
                        control={<Radio color="primary" />}
                        label="受け付ける"
                      />
                    </RadioGroup>
                  </TableCell>
                </TableRow> */}
                <TableRow className={classes.verticalAlignTop}>
                  <TableCell>
                    <RequiredButton />
                  </TableCell>
                  <TableCell className={classes.paddingTop0}>
                    <Typography className={classes.description}>
                      社食ごちめし金額指定チケット利用の有無
                    </Typography>
                    <RadioGroup
                      row
                      value={allowMenuPriceShashoku}
                      onChange={e => {
                        setAllowMenuPriceShashoku(parseInt(e.target.value, 0));
                      }}
                    >
                      <FormControlLabel
                        selected
                        disabled={
                          groupDetail && groupDetail.groupType !== 'OTHERS'
                        }
                        value={1}
                        control={<Radio color="primary" />}
                        label="利用する"
                      />
                      <FormControlLabel
                        value={0}
                        disabled={
                          groupDetail && groupDetail.groupType !== 'OTHERS'
                        }
                        control={<Radio color="primary" />}
                        label="利用しない"
                      />
                    </RadioGroup>
                  </TableCell>
                </TableRow>
                <TableRow className={classes.verticalAlignTop}>
                  <TableCell className={classes.tableCellBorderNone}>
                    <RequiredButton />
                  </TableCell>
                  <TableCell
                    component="p"
                    className={[
                      classes.tableCellBorderNone,
                      classes.paddingTop0
                    ]}
                  >
                    <Typography className={classes.description}>
                      売上受取方法
                    </Typography>
                    {!enableShopBank && (
                      <Typography className={classes.descriptionSmall}>
                        ※貴グループ運営会社で銀行口座情報がすでに登録されているため、店舗ごとの入金管理の登録は不要です。
                      </Typography>
                    )}
                    <RadioGroup
                      value={!enableShopBank ? 'NOT_MANAGE' : depositManage}
                      onChange={e => {
                        setDepositManage(e.target.value);
                        convertDepositManageStr(e.target.value);
                      }}
                    >
                      <FormControlLabel
                        value="SELF"
                        control={
                          <Radio color="primary" disabled={!enableShopBank} />
                        }
                        label="Stripe経由で受取（週1回入金）"
                      />
                      <FormControlLabel
                        value="NONSELF"
                        control={
                          <Radio color="primary" disabled={!enableShopBank} />
                        }
                        label="銀行口座で直接受取（月1回入金）（オプション）"
                      />
                    </RadioGroup>
                    <Typography variant="h7">
                      [Stripe経由で受取（週1回入金）]
                      <br />
                      Stripe紐付けを行うことで、振込サイクルの変更や入金日のご確認ができるようになります
                      <br />
                      <br />
                      [銀行口座で直接受取（月1回入金）（オプション）]
                      <br />
                      月末締め翌月5営業日以内に当社より振込みいたします（振込手数料は貴社負担）。後から「Stripe経由で受取（週1回入金）」へ変更することも可能です。
                    </Typography>
                  </TableCell>
                  {/* <TableCell className={classes.tableCellBorderNone}>
                    [Stripe経由で受取（週1回入金）]
                    <br />
                    Stripe紐付けを行うことで、振込サイクルの変更や入金日のご確認ができるようになります
                    <br />
                    <br />
                    [銀行口座で直接受取（月1回入金）（オプション）]
                    <br />
                    月末締め翌月5営業日以内に当社より振込みいたします（振込手数料は貴社負担）。後から「Stripe経由で受取（週1回入金）」へ変更することも可能です。
                  </TableCell> */}
                </TableRow>
                {depositManage === 'NONSELF' && (
                  <>
                    <TableRow>
                      <TableCell className={classes.tableCellBorderNone} />
                      <TableCell className={classes.tableCellBorderNone}>
                        <TextField
                          required
                          label="銀行コード"
                          placeholder="0000"
                          disabled={!enableShopBank}
                          className={classes.textFieldFull}
                          margin="normal"
                          onChange={e => {
                            handleChangeBankCode(e.target.value);
                          }}
                          value={bankCode}
                          onBlur={validBankCode}
                          inputProps={{
                            maxLength: 4,
                            inputMode: 'numeric'
                          }}
                        />
                        <Typography className={`${classes.font14}`}>
                          ※
                          <Link
                            href="https://zengin.ajtw.net/"
                            target="_blank"
                            className={classes.link}
                          >
                            検索サイト
                          </Link>
                        </Typography>
                        <Typography style={{ fontSize: 14 }}>
                          半角数字・4桁（3桁以下の方は、先頭に0をつけて4桁にしてください）
                        </Typography>
                        <ValidationText message={errors.bankCodeError} />
                      </TableCell>
                      <TableCell className={classes.tableCellBorderNone} />
                    </TableRow>
                    <TableRow>
                      <TableCell className={classes.tableCellBorderNone} />
                      <TableCell className={classes.tableCellBorderNone}>
                        <TextField
                          label="銀行名"
                          className={`${classes.textFieldFull} ${
                            classes.disableInput
                          }`}
                          margin="normal"
                          value={bankName}
                          disabled
                        />
                      </TableCell>
                      <TableCell className={classes.tableCellBorderNone} />
                    </TableRow>
                  </>
                )}
                {depositManage === 'NONSELF' && (
                  <>
                    <TableRow>
                      <TableCell className={classes.tableCellBorderNone} />
                      <TableCell className={classes.tableCellBorderNone}>
                        <TextField
                          required
                          label="支店コード"
                          placeholder="000"
                          disabled={!enableShopBank}
                          className={classes.textFieldFull}
                          margin="normal"
                          onChange={e => {
                            setBankBranchCode(e.target.value);
                            setBankBranchName('');
                          }}
                          onBlur={validBankBranchCode}
                          value={bankBranchCode}
                          inputProps={{
                            maxLength: 3,
                            inputMode: 'numeric'
                          }}
                        />
                        <Typography className={`${classes.font14}`}>
                          ※
                          <Link
                            href="https://zengin.ajtw.net/"
                            target="_blank"
                            className={classes.link}
                          >
                            検索サイト
                          </Link>
                        </Typography>
                        <Typography className={`${classes.font14}`}>
                          半角数字・3桁（2桁以下の方は、先頭に0をつけて3桁にしてください）
                        </Typography>
                        <ValidationText message={errors.bankBranchCodeError} />
                      </TableCell>
                      <TableCell className={classes.tableCellBorderNone} />
                    </TableRow>
                    <TableRow>
                      <TableCell className={classes.tableCellBorderNone} />
                      <TableCell className={classes.tableCellBorderNone}>
                        <TextField
                          label="支店名"
                          disabled
                          className={`${classes.textFieldFull} ${
                            classes.disableInput
                          }`}
                          margin="normal"
                          value={bankBranchName}
                        />
                      </TableCell>
                      <TableCell className={classes.tableCellBorderNone} />
                    </TableRow>
                  </>
                )}
                {depositManage === 'NONSELF' && (
                  <TableRow>
                    <TableCell className={classes.tableCellBorderNone} />
                    <TableCell className={classes.tableCellBorderNone}>
                      <Typography className={classes.description}>
                        口座種別
                      </Typography>
                      <RadioGroup
                        row
                        value={bankAccountType}
                        onChange={e => {
                          setBankAccountType(e.target.value);
                          convertBankAccountTypeStr(e.target.value);
                        }}
                      >
                        <FormControlLabel
                          value="SAVINGS"
                          control={
                            <Radio color="primary" disabled={!enableShopBank} />
                          }
                          label="普通預金"
                        />
                        <FormControlLabel
                          value="CHECKING"
                          control={
                            <Radio color="primary" disabled={!enableShopBank} />
                          }
                          label="当座預金"
                        />
                      </RadioGroup>
                    </TableCell>
                    <TableCell className={classes.tableCellBorderNone} />
                  </TableRow>
                )}
                {depositManage === 'NONSELF' && (
                  <TableRow>
                    <TableCell className={classes.tableCellBorderNone} />
                    <TableCell className={classes.tableCellBorderNone}>
                      <TextField
                        required
                        label="口座番号"
                        placeholder="1234567"
                        disabled={!enableShopBank}
                        className={classes.textFieldFull}
                        margin="normal"
                        onChange={e => {
                          setBankAccountNumber(e.target.value);
                        }}
                        onBlur={validBankAccountNumber}
                      />
                      <ValidationText message={errors.bankAccountNumberError} />
                      <Typography variant="h7">
                        半角数字・7桁（6桁以下の方は先頭に0をつけて7桁にしてください）
                      </Typography>
                    </TableCell>
                    {/* <TableCell className={classes.tableCellBorderNone}>
                      半角数字・7桁（6桁以下の方は先頭に0をつけて7桁にしてください）
                    </TableCell> */}
                  </TableRow>
                )}
                {depositManage === 'NONSELF' && (
                  <TableRow>
                    <TableCell className={classes.tableCellBorderNone} />
                    <TableCell className={classes.tableCellBorderNone}>
                      <TextField
                        required
                        label="口座名義"
                        placeholder="ヤマダ　タロウ"
                        disabled={!enableShopBank}
                        className={classes.textFieldFull}
                        margin="normal"
                        onChange={e => {
                          setBankAccountHolder(e.target.value);
                        }}
                        onBlur={validBankAccountHolder}
                      />
                      <ValidationText message={errors.bankAccountHolderError} />
                      <Typography variant="h7">
                        必ず漢字/ひらがな以外でご記入ください。
                      </Typography>
                    </TableCell>
                    {/* <TableCell className={classes.tableCellBorderNone}>
                      必ず漢字/ひらがな以外でご記入ください。
                    </TableCell> */}
                  </TableRow>
                )}
                {depositManage === 'SELF' && (
                  <TableRow>
                    <TableCell className={classes.tableCellBorderNone} />
                    <TableCell className={classes.tableCellBorderNone}>
                      <Typography variant="h7">
                        <Divider />
                        <br />
                        第3者の決済サービス「Stripe&nbsp;Connect」を利用して頂く事で、自社で入金サイクル（基本は毎週）を変更したり、振込手数料を無料にする事ができます。こちらのオプションを選んだ場合は、以下の設定を行って頂きます。
                        <br />
                        <br />
                        ①&nbsp;Stripeでアカウントを作成する。
                        <br />
                        ②&nbsp;ごちめしを運営する当社のStripeアカウントに紐付けを行う。
                        <br />
                        ③&nbsp;初回入金時に、Stripe社より送られる案内メールにしたがって、本人確認資料を提出する。
                        <br />
                        <br />
                        管理画面左上の三本線メニューから、「その他」→「自社で入金管理（オプション）」を選んで頂くと、上記の①および②の設定が一度に行う事ができます。設定の詳細については、当管理システムのトップページから「ごちめし店舗登録マニュアルはこちら」をご参照ください。
                      </Typography>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TabPanelDetail>

          <TabPanelDetail value={valueTab} index={1}>
            <Table className={classes.editTable}>
              <TableBody>
                <TableRow className={classes.verticalAlignTop}>
                  <TableCell>
                    <AnyButton />
                  </TableCell>
                  <TableCell className={classes.paddingTop0}>
                    <TextField
                      label="店舗概要"
                      placeholder="創業年、お店の特徴、雰囲気　など"
                      className={classes.textFieldFull}
                      margin="normal"
                      onChange={e => {
                        setIntroduction(e.target.value);
                      }}
                    />
                  </TableCell>
                  <TableCell />
                </TableRow>
                <TableRow className={classes.verticalAlignTop}>
                  <TableCell>
                    <AnyButton />
                  </TableCell>
                  <TableCell className={classes.paddingTop0}>
                    <TextField
                      label="営業時間"
                      placeholder="平日11：00～14：00 （LO 13：30）/土日祝11：00～14：00 （LO 13：30）"
                      className={classes.textFieldFull}
                      margin="normal"
                      onChange={e => {
                        setBusinessHours(e.target.value);
                      }}
                    />
                  </TableCell>
                  <TableCell />
                </TableRow>
                <TableRow className={classes.verticalAlignTop}>
                  <TableCell>
                    <AnyButton />
                  </TableCell>
                  <TableCell className={classes.paddingTop0}>
                    <TextField
                      label="定休日"
                      placeholder="第2・第4土曜、日曜、祝日"
                      className={classes.textFieldFull}
                      margin="normal"
                      onChange={e => {
                        setHoliday(e.target.value);
                      }}
                    />
                  </TableCell>
                  <TableCell />
                </TableRow>
                <TableRow className={classes.verticalAlignTop}>
                  <TableCell>
                    <AnyButton />
                  </TableCell>
                  <TableCell className={classes.paddingTop0}>
                    <TextField
                      label="価格帯"
                      placeholder="○○～○○円"
                      className={classes.textFieldFull}
                      margin="normal"
                      onChange={e => {
                        setPriceRange(e.target.value);
                      }}
                    />
                  </TableCell>
                  <TableCell />
                </TableRow>
                <TableRow className={classes.verticalAlignTop}>
                  <TableCell>
                    <AnyButton />
                  </TableCell>
                  <TableCell className={classes.paddingTop0}>
                    <TextField
                      label="最寄り駅"
                      placeholder="○○線○○駅"
                      className={classes.textFieldFull}
                      margin="normal"
                      onChange={e => {
                        setNearestStation(e.target.value);
                      }}
                    />
                  </TableCell>
                  <TableCell />
                </TableRow>
                <TableRow className={classes.verticalAlignTop}>
                  <TableCell>
                    <AnyButton />
                  </TableCell>
                  <TableCell className={classes.paddingTop0}>
                    <TextField
                      label="アクセス"
                      placeholder="（交通手段、最寄り駅など）より○○分"
                      className={classes.textFieldFull}
                      margin="normal"
                      onChange={e => {
                        setAccess(e.target.value);
                      }}
                    />
                  </TableCell>
                  <TableCell />
                </TableRow>
                <TableRow className={classes.verticalAlignTop}>
                  <TableCell>
                    <AnyButton />
                  </TableCell>
                  <TableCell className={classes.paddingTop0}>
                    <TextField
                      label="WebページURL"
                      placeholder="https://www.test.com/"
                      className={classes.textFieldFull}
                      margin="normal"
                      onChange={e => {
                        setWebPage(e.target.value);
                      }}
                    />
                  </TableCell>
                  <TableCell />
                </TableRow>
                <TableRow className={classes.verticalAlignTop}>
                  <TableCell>
                    <AnyButton />
                  </TableCell>
                  <TableCell className={classes.paddingTop0}>
                    <TextField
                      label="タグ"
                      className={classes.textFieldFull}
                      margin="normal"
                      onChange={e => {
                        setTagStr(e.target.value);
                        splitTagStr(e.target.value);
                      }}
                      onBlur={validTag}
                    />
                    <ValidationText message={errors.tagError} />
                    <Typography variant="h7">
                      #イタリアン #飲み会に #港区 など、半角の#をつけて
                      <span className={classes.tagCaution}>
                        スペースで区切ってください。
                      </span>
                      店舗のカテゴリー・特徴・売りなどをこちらのタグで表現して頂きます。
                    </Typography>
                  </TableCell>
                </TableRow>
                <TableRow className={classes.verticalAlignTop}>
                  <TableCell>
                    <AnyButton />
                  </TableCell>
                  <TableCell className={classes.paddingTop1}>
                    <Typography variant="h7" color="textSecondary">
                      画像
                    </Typography>
                    <FileUpload
                      label="image1"
                      setFile={setImage1}
                      previewImage={previewImage1}
                      setPreviewImage={setPreviewImage1}
                      className={classes.textFieldFull}
                    />
                    <FileUpload
                      label="image2"
                      setFile={setImage2}
                      previewImage={previewImage2}
                      setPreviewImage={setPreviewImage2}
                    />
                    <FileUpload
                      label="image3"
                      setFile={setImage3}
                      previewImage={previewImage3}
                      setPreviewImage={setPreviewImage3}
                    />
                    <FileUpload
                      label="image4"
                      setFile={setImage4}
                      previewImage={previewImage4}
                      setPreviewImage={setPreviewImage4}
                    />
                    <FileUpload
                      label="image5"
                      setFile={setImage5}
                      previewImage={previewImage5}
                      setPreviewImage={setPreviewImage5}
                    />
                    <Typography variant="h7">
                      画像は５枚まで登録できます。複数枚登録した場合は、店舗詳細画面でスライド表示されます。店舗一覧には１番目に登録した画像が表示されます。
                    </Typography>
                  </TableCell>
                </TableRow>
                <TableRow className={classes.verticalAlignTop}>
                  <TableCell>
                    <AnyButton />
                  </TableCell>
                  <TableCell className={classes.paddingTop1}>
                    <Typography variant="h7" color="textSecondary">
                      SNS
                    </Typography>
                    <div>
                      <Grid container spacing={1} alignItems="flex-end">
                        <Grid item>
                          <CardMedia
                            component="img"
                            alt="Facebook"
                            height="24"
                            image="/images/icon_facebook.png"
                            title="Facebook"
                            className={classes.marginBottom10}
                          />
                        </Grid>
                        <Grid item>
                          <TextField
                            label="Facebook"
                            placeholder="https://www.facebook.com/---"
                            className={classes.textFieldFull}
                            margin="normal"
                            onChange={e => {
                              setSnsFacebook(e.target.value);
                            }}
                            onBlur={validSnsFacebook}
                          />
                        </Grid>
                      </Grid>
                      <ValidationText message={errors.snsFacebookError} />
                      <Grid container spacing={1} alignItems="flex-end">
                        <Grid item>
                          <CardMedia
                            component="img"
                            alt="Twitter"
                            height="24"
                            image="/images/icon_twitter.png"
                            title="Twitter"
                            className={classes.marginBottom10}
                          />
                        </Grid>
                        <Grid item>
                          <TextField
                            label="Twitter"
                            placeholder="https://www.twitter.com/---"
                            className={classes.textFieldFull}
                            margin="normal"
                            onChange={e => {
                              setSnsTwitter(e.target.value);
                            }}
                            onBlur={validSnsTwitter}
                          />
                        </Grid>
                      </Grid>
                      <ValidationText message={errors.snsTwitterError} />
                      <Grid container spacing={1} alignItems="flex-end">
                        <Grid item>
                          <CardMedia
                            component="img"
                            alt="Instagram"
                            height="24"
                            image="/images/icon_instagram.png"
                            title="Instagram"
                            className={classes.marginBottom10}
                          />
                        </Grid>
                        <Grid item>
                          <TextField
                            label="Instagram"
                            placeholder="https://www.instagram.com/---"
                            className={classes.textFieldFull}
                            margin="normal"
                            onChange={e => {
                              setSnsInstagram(e.target.value);
                            }}
                            onBlur={validSnsInstagram}
                          />
                        </Grid>
                      </Grid>
                      <ValidationText message={errors.snsInstagramError} />
                    </div>
                  </TableCell>
                  <TableCell />
                </TableRow>
                <TableRow className={classes.verticalAlignTop}>
                  <TableCell>
                    <AnyButton />
                  </TableCell>
                  <TableCell className={classes.paddingTop0}>
                    <TextField
                      label="座席"
                      placeholder="カウンター○席、個室○室"
                      className={classes.textFieldFull}
                      margin="normal"
                      onChange={e => {
                        setNumberSit(e.target.value);
                      }}
                    />
                  </TableCell>
                  <TableCell />
                </TableRow>
                <TableRow className={classes.verticalAlignTop}>
                  <TableCell>
                    <AnyButton />
                  </TableCell>
                  <TableCell className={classes.paddingTop0}>
                    <TextField
                      label="禁煙/喫煙"
                      placeholder=""
                      className={classes.textFieldFull}
                      margin="normal"
                      onChange={e => {
                        setSmoking(e.target.value);
                      }}
                    />
                  </TableCell>
                  <TableCell />
                </TableRow>
                <TableRow className={classes.verticalAlignTop}>
                  <TableCell>
                    <AnyButton />
                  </TableCell>
                  <TableCell className={classes.paddingTop0}>
                    <TextField
                      label="駐車場"
                      placeholder="お店から徒歩○分に〇台"
                      className={classes.textFieldFull}
                      margin="normal"
                      onChange={e => {
                        setParking(e.target.value);
                      }}
                    />
                  </TableCell>
                  <TableCell />
                </TableRow>
                {/* <TableRow className={classes.verticalAlignTop}>
                  <TableCell>
                    <AnyButton />
                  </TableCell>
                  <TableCell className={classes.paddingTop0}>
                    <TextField
                      required
                      select
                      label="ごちめしの紹介者"
                      className={classes.textFieldFull}
                      margin="normal"
                      value={preGochiUser}
                      onChange={e => {
                        setPreGochiUser(e.target.value);
                        convertPreGochiUserStr(e.target.value);
                      }}
                      InputLabelProps={{
                        shrink: true
                      }}
                    >
                      {detail.preGochis.map(item => {
                        return (
                          <MenuItem key={item.userId} value={item.userId}>
                            {item.accountId}
                            &#40;
                            {item.displayName}
                            &#41; &#91;
                            {item.amount}
                            &#93;
                          </MenuItem>
                        );
                      })}
                    </TextField>
                    <Typography variant="h7">
                      ごちめしへの参加を促してくれたユーザーで、店舗の仮登録をしてくれたユーザーを指します。
                    </Typography>
                  </TableCell>
                </TableRow> */}
              </TableBody>
            </Table>
          </TabPanelDetail>
        </div>
        <div>
          <CancelButton onClickAction={cancelAction} color="primary" />
          <ConfirmButton onClickAction={confirmAction} />
        </div>
        <Modal open={openShopAddConfirm}>
          <ShopAddConfirmGroup
            updateOpenShopAdd={updateOpenShopAdd}
            updateOpenShopAddConfirm={updateOpenShopAddConfirm}
            backAction={backAction}
            registerAction={registerAction}
            addConfirm={addConfirm}
            addParam={addParam}
            prefectures={prefectures}
            setCognitoUserId={setCognitoUserId}
            enableShopBank={enableShopBank}
            searchKey={searchKey}
            groupShop={groupShop}
            shopCategories={shopCategories}
            onAddSuccess={onAddSuccess}
          />
        </Modal>
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
